import api from "./axiosConfig";

export interface AppInstallData {
  date: string;
  count: number;
}

export interface MonthlyAppInstallData {
  month: string;
  count: number;
}

export interface AppInstallsStatsResponse {
  ios: AppInstallData[];
  android: AppInstallData[];
  web: AppInstallData[];
  totalIos: number;
  totalAndroid: number;
  totalWeb: number;
}

export interface MonthlyAppInstallsStatsResponse {
  ios: MonthlyAppInstallData[];
  android: MonthlyAppInstallData[];
  web: MonthlyAppInstallData[];
  totalIos: number;
  totalAndroid: number;
  totalWeb: number;
}

export interface LifetimeAppInstallsStatsResponse {
  totalIos: number;
  totalAndroid: number;
  totalWeb: number;
}

// New interfaces for engagement time stats
export interface EngagementTimeData {
  date: string;
  secondsCount: number;
}

export interface MonthlyEngagementTimeData {
  month: string;
  secondsCount: number;
}

export interface EngagementTimeStatsResponse {
  ios: EngagementTimeData[];
  android: EngagementTimeData[];
  web: EngagementTimeData[];
  totalSecondsCountIos: number;
  totalSecondsCountAndroid: number;
  totalSecondsCountWeb: number;
}

export interface MonthlyEngagementTimeStatsResponse {
  ios: MonthlyEngagementTimeData[];
  android: MonthlyEngagementTimeData[];
  web: MonthlyEngagementTimeData[];
  totalSecondsCountIos: number;
  totalSecondsCountAndroid: number;
  totalSecondsCountWeb: number;
}

export interface LifetimeEngagementTimeStatsResponse {
  secondsCountIos: number;
  secondsCountAndroid: number;
  secondsCountWeb: number;
}

export const getDailyAppInstallsStatsForAdmin = async (
  from?: string,
  to?: string
): Promise<AppInstallsStatsResponse> => {
  try {
    const response = await api.post(
      "/business-account/get-daily-app-installs-stats-for-admin",
      {
        from,
        to,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Getting app installs stats error:", error);
    throw error;
  }
};

export const getMonthlyAppInstallsStatsForAdmin = async (
  from?: string,
  to?: string
): Promise<MonthlyAppInstallsStatsResponse> => {
  try {
    const response = await api.post(
      "/business-account/get-monthly-app-installs-stats-for-admin",
      {
        from,
        to,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Getting monthly app installs stats error:", error);
    throw error;
  }
};

export const getLifetimeAppInstallsStatsForAdmin =
  async (): Promise<LifetimeAppInstallsStatsResponse> => {
    try {
      const response = await api.post(
        "/business-account/get-lifetime-app-installs-stats-for-admin", {}
      );
      return response.data;
    } catch (error) {
      console.error("Getting lifetime app installs stats error:", error);
      throw error;
    }
  };

// New methods for engagement time stats
export const getDailyEngagementTimeStatsForAdmin = async (
  from?: string,
  to?: string
): Promise<EngagementTimeStatsResponse> => {
  try {
    const response = await api.post(
      "/business-account/get-daily-average-engagement-time-stats-for-admin",
      {
        from,
        to,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Getting daily engagement time stats error:", error);
    throw error;
  }
};

export const getMonthlyEngagementTimeStatsForAdmin = async (
  from?: string,
  to?: string
): Promise<MonthlyEngagementTimeStatsResponse> => {
  try {
    const response = await api.post(
      "/business-account/get-monthly-average-engagement-time-stats-for-admin",
      {
        from,
        to,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Getting monthly engagement time stats error:", error);
    throw error;
  }
};

export const getLifetimeEngagementTimeStatsForAdmin =
  async (): Promise<LifetimeEngagementTimeStatsResponse> => {
    try {
      const response = await api.post(
        "/business-account/get-lifetime-average-engagement-time-stats-for-admin", {}
      );
      return response.data;
    } catch (error) {
      console.error("Getting lifetime engagement time stats error:", error);
      throw error;
    }
  };
